import JSEncrypt from "jsencrypt";
import { parseBigInt } from "jsencrypt/lib/lib/jsbn/jsbn";

/**
 * 加密
 * @password 加密字段
 */
const publicKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClkzAc+2K/PwA1AXykWxgoSJspsKd4Es6fZjcX+ycioI4JFirE/Ef5h0R1yf1jjUiJLMEwFUWWCs+fpMx3cTe7ZANHJXg7tT1MPt50jRxulmY9Sit5gkV72yz+aOyzGq6F232qTpi7xwLGKOxd21pHIcqzGIsj1PrViuahSZqyWQIDAQAB";

export const encrypt = (password) => {
  if (!password) return;
  // 创建RSA对象
  const encryptor = new JSEncrypt();
  // 设置公钥
  encryptor.setPublicKey(publicKey);
  // 使用PKCS1进行加密
  const encrypted = encryptor.encrypt(password);
  // 更新加密结果
  return encrypted;
};

function pkcs1unpad2(d, n) {
  var b = d.toByteArray();
  var i = 0;
  while (i < b.length && b[i] === 0) {
    ++i;
  }
  // if (b.length - i !== n - 1 || b[i] !== 2) {
  //   return null
  // }
  ++i;
  while (b[i] !== 0) {
    if (++i >= b.length) {
      return null;
    }
  }
  var ret = "";
  while (++i < b.length) {
    var c = b[i] & 255;
    if (c < 128) {
      // utf-8 decode
      ret += String.fromCharCode(c);
    } else if (c > 191 && c < 224) {
      ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
      ++i;
    } else {
      ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
      i += 2;
    }
  }
  return ret;
}

//重写JSEncrypt方法，支持公钥解密
export const rsaDecrypt = (data) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  // 不支持公钥解密
  // 自定义解析方法支持公钥解析
  const rsaKey = encrypt.getKey();
  rsaKey.decrypt = function (ctext) {
    var c = parseBigInt(ctext, 16);
    var m = this.doPublic(c);
    if (m == null) {
      return null;
    }
    return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
  };
  return encrypt.decrypt(data);
};
